<div class="" *ngIf="candidateListTotalCount && candidateList && !showLoaderbeforeDataLoad" id="candidate-list">
  <div class="sticktotop">
    <div *ngFor="let data of candidateList; let i = index">
      <app-candidate-quick-view [data]="data" [i]="i" parent="TalentpoolRecommendedCandidateListComponent" [highlightkeywords]="null" (childEvents)="eventHandler($event)" [similarobjectdata]="null" (refreshCurrentView)="refreshCurrentView($event)">
        <div talentPoolBulkGrab>
          <label class="wc-checkbox mr-3 mt-3">
            <input data-testid="auto-app-talentpool-suggested-candidate-list-input-1" [checked]="data.selected" [(ngModel)]="data.selected"
              (change)="selectCandidate($event, data)" type="checkbox" id="mycheck" name="mycheck">
            <i class="fas fa-check"></i>
          </label>
        </div>

        <div *ngIf="candidatetoBeGrabbed.length <=1 && !selected" addToTalentPool>
          <p class="add-to-talentpool pointer text-nowrap" [ngClass]="{ 'text-webbtree-green': !isLoading }"  [ngStyle]="{ 'cursor': isLoading ? 'not-allowed' : 'pointer', 'border-color': isLoading ? '#969696' : '' }" (click)="!isLoading && moveToTalentpool(data)">
            <i class="fas fa-user-plus mr-1"></i>
            Move to Talent pool
          </p>
        </div>
      </app-candidate-quick-view>
    </div>
  </div>
</div>

<div class="h-50 justify-content-center wccard d-flex flex-column align-items-center" *ngIf="showLoaderbeforeDataLoad" style="height: 50vh !important;">
  <div class="loader text-center" *ngIf="showLoaderbeforeDataLoad">
    <img *ngIf="showLoaderbeforeDataLoad" style="width: 75px;" src="assets/rolling-loader.gif" alt="loader" />
  </div>
</div>

<div class="empty-state" *ngIf="(!candidateList || !candidateList.length) && !showLoaderbeforeDataLoad">
  <div class="text-center wccard py-4">
    <img src="assets/images/talentpool_suggestions_empty.png" alt="empty-state" class="empty-state-img mt-4">
    <p class="f-14 font-weight-600 my-4">
      Recommendations are not available yet
    </p>
    <p class="f-14 font-weight-normal mb-4">
      Add more candidates to your talent pool to start seeing the best matches! Our <br/>
      AI-powered system will provide tailored suggestions as your pool grows.
    </p>
  </div>
</div>

<div class="row justify-content-start">
  <div id="overlay" (click)="closeNav()">
  </div>
</div>

<div id="quickView">
  <div class="" *ngIf="showCandidate">
    <app-person-search-candidate-slider [data]="currentCandidate" parent="TalentpoolRecommendedCandidateListComponent" [viewMoreSkills]="viewMoreSkills" [highlightkeywords]="highlightkeywords" [tabType]="tabType" (childEvents)="eventHandler($event)" (handleOutputEvent) = "eventHandler($event)" [currentIndex]="currentIndex" >
      <div addToTalentPool class="d-inline-flex">
        <div>
          <p class="add-to-talentpool text-webbtree-green pointer mr-2 text-nowrap" (click)="moveToTalentpool(currentCandidate)">
            <i class="fas fa-user-plus mr-1"></i>
            Move to Talent pool
          </p>
        </div>
      </div>
    </app-person-search-candidate-slider>
  </div>
</div>